import React, { useRef, useEffect, useState } from "react";
// Componente de alerta
const AlertaCSV = ({ idsNoEncontrados, onClose }) => {
    const [visible, setVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            onClose();
        }, 30000); // 30 segundos

        return () => clearTimeout(timer);
    }, [onClose]);

    const handleClose = () => {
        setVisible(false);
        onClose();
    };

    if (!visible) return null;

    return (
        <div style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1050,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            padding: "16px 24px",
            maxWidth: "500px",
            textAlign: "center"
        }}>
            <div style={{ marginBottom: "12px", fontSize: "14px", color: "#333" }}>
                <div style={{ marginBottom: "8px", fontWeight: "bold" }}>
                    Efectos no encontrados:
                </div>
                {idsNoEncontrados.map((id, index) => (
                    <div key={index}>Efecto: {id}</div>
                ))}
            </div>
            <button
                onClick={handleClose}
                style={{
                    backgroundColor: "#4285f4",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    padding: "8px 16px",
                    fontSize: "14px",
                    cursor: "pointer",
                    fontWeight: "500"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#3367d6"}
                onMouseOut={(e) => e.target.style.backgroundColor = "#4285f4"}
            >
                Aceptar
            </button>
        </div>
    );
};

export default AlertaCSV;
